import React, { forwardRef } from 'react';
import { RadioButton } from "@ui5/webcomponents-react";
import * as RadioButtonGroupHelper from './RadioButtonGroup.helper';

export default forwardRef(
  ({ options, texts, value, horizontal = true, onChange, style = {} }, ref) => {

    return (
      <div style={{ ...style }} ref={ref} data-testid="radio-button-wrapper">
        {options.map((option, index) => {
          return (
            <RadioButton
              data-testid={`radio-button-${index}`}
              style={{ display: horizontal ? 'inline-block' : 'block' }}
              key={option}
              checked={option === value}
              text={texts[index]}
              onSelect={event => {
                RadioButtonGroupHelper.onSelectHandler(onChange, event, option, texts[index], index);
              }}
            />
          );
        })}
      </div>
    );
  },
);
